module.exports = __webpack_public_path__ + "img/gq16.41cfe50d.png";